import { useEffect, useState } from "react";

// Keeps something on screen for `ms` after it is switched off, so it can play a
// closing animation instead of vanishing. `value` is the thing's current state
// (falsy = closed); the result is what to render and whether it is on its way out.
export function useExitDelay(value, ms = 180) {
  const [kept, setKept] = useState(value || false);

  useEffect(() => {
    if (value) {
      setKept(value);
      return undefined;
    }
    const t = setTimeout(() => setKept(false), ms);
    return () => clearTimeout(t);
  }, [value, ms]);

  return { value: value || kept, leaving: !value && !!kept };
}
